const columns = [
    {
      name: 'Account Name',
      selector: (row) => row?.users_name_tx,
    },
    {
      name: 'Email',
      selector: (row) => row?.email_tx,
    },
    
    
  ];
  const mobileColumns = [
    {
      name: 'Account Name',
      selector: (row) => row?.users_name_tx,
    },
    {
      name: 'Email',
      selector: (row) => row?.email_tx,
    },
  ];
  
  export { columns, mobileColumns };
  